<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>
<ng-template #errorBlock>
  <app-error></app-error>
</ng-template>
<div class="hiring-wrapper">
  <app-grouped-bar-chart
    *ngIf="hiringAttrition; else errorBlock"
    [name]="'hiringAttrition'"
    [data]="hiringAttrition"
    [columns]="columns"
    [colors]="colors"
    [legends]="legends"
  ></app-grouped-bar-chart>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
